import types from 'constants/actionTypes';
import { createThunk } from 'utils/createThunk';
import * as backendAPI from 'api/backendAPI/userSetting';

export const fetchUserSetting = createThunk({
  apiCall: backendAPI.fetchUserSetting,
  type: types.FETCH_USER_SETTING_REQUEST,
});

export const updateUserSetting = createThunk({
  apiCall: backendAPI.updateUserSetting,
  type: types.UPDATE_USER_SETTING_REQUEST,
});

export const toggleUserSetting = payload => ({
  type: types.TOGGLE_USER_SETTING,
  payload,
});
